/// <amd-module name="Test/Analytics/TestResultsGridCommon/Components/ClickableLabel" />
import * as React from "react";
import * as Resources from "Test/Analytics/TestResultsGridCommon/Resources";
import { localeFormat } from "VSS/Core/Util/String";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { css } from "VSSUI/Util";

export interface IClickableLabelProps extends IVssComponentProperties {
    value: string;
    onClick?: () => void;
    showLoadingOnClick?: boolean;
}

export interface IClickableLabelState {
    isLoading?: boolean;
}

/*
 * This class renders a text populated span which on hover is underlined
 * Property onClick must be set for appropriate hover css to render
 */
export class ClickableLabel extends VssComponent<IClickableLabelProps, IClickableLabelState, IVssComponentContext> {
    public static getDerivedStateFromProps(nextProps: IClickableLabelProps, prevState: IClickableLabelState): IClickableLabelState | null {
        if (nextProps && !nextProps.showLoadingOnClick) {
            return { isLoading: false } as IClickableLabelState;
        }
        return null;
    }

    constructor(props: IClickableLabelProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { isLoading: false } as IClickableLabelState;
    }

    public render(): JSX.Element {
        const className: string = css(
            "flex",
            this.props.cssClass,
            this.props.onClick ? "clickable-label-text-hoverable-link" : "clickable-label-text",
            this.props.showLoadingOnClick ? "clickable-label-loading-message" : ""
        );
        if (this.state.isLoading) {
            return (
                <div className={className}>
                    <Spinner className="flex clickable-label-loading-spinner" size={SpinnerSize.small} />
                    <span>{Resources.LoadingMessage}</span>
                </div>
            );
        } else {
            let ariaLabel = "";
            if (this.props.value) {
                ariaLabel = this.props.ariaLabel ? this.props.ariaLabel : localeFormat("{0} {1} ", this.props.value, Resources.LinkText);
            }
            return (
                <span className={className} onClick={this._onClick} aria-label={ariaLabel}>
                    {this.props.value}
                </span>
            );
        }
    }

    private _onClick = (): void => {
        if (this.props.showLoadingOnClick) {
            this.setState({ isLoading: true });
        }

        if (this.props.onClick) {
            this.props.onClick();
        }
    };
}
